import { render } from "./SsamHome.vue?vue&type=template&id=23531a45&ts=true"
import script from "./SsamHome.vue?vue&type=script&lang=ts"
export * from "./SsamHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SsamHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23531a45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23531a45', __exports__)) {
    api.reload('23531a45', __exports__)
  }
  
  module.hot.accept("./SsamHome.vue?vue&type=template&id=23531a45&ts=true", () => {
    api.rerender('23531a45', render)
  })

}


export default __exports__